import { i18n } from "@lingui/core";
import { msg } from "@lingui/macro";
import type { UrlDto } from "@stylingcv/dto";
import { useMutation } from "@tanstack/react-query";

import { toast } from "@/client/hooks/use-toast";
import { axios } from "@/client/libs/axios";
import { trackResumeEvent } from "@/client/utils/gtm";

export const printResume = async (data: { id: string; resumeData?: any }) => {
  // Track PDF export
  trackResumeEvent.export("pdf");

  let result: UrlDto;

  if (data.resumeData) {
    const response = await axios.post<UrlDto>(`/resume/${data.id}/export/pdf`, data.resumeData);
    result = response.data;
  } else {
    const response = await axios.get<UrlDto>(`/resume/print/${data.id}`);
    result = response.data;
  }

  // Fire-and-forget: increment the PDF download counter tracked in the admin panel
  axios.post(`/resume/${data.id}/statistics`).catch(() => {/* silent */});

  return result;
};

export const printResumeTest = async (data: { id: string }) => {
  const response = await axios.get<UrlDto>(`/resume/print/${data.id}/test`);

  return response.data;
};

export const usePrintResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: printResumeFn,
  } = useMutation({
    mutationFn: printResume,
    onError: (error) => {
      const message = error.message;

      toast({
        variant: "error",
        title: i18n._(msg`Oops, the server returned an error.`),
        description: message,
      });
    },
  });

  return { printResume: printResumeFn, loading, error };
};

export const usePrintResumeTest = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: printResumeTestFn,
  } = useMutation({
    mutationFn: printResumeTest,
    onError: (error) => {
      const message = error.message;

      toast({
        variant: "error",
        title: i18n._(msg`Oops, the server returned an error.`),
        description: message,
      });
    },
  });

  return { printResumeTest: printResumeTestFn, loading, error };
};
